import { render, staticRenderFns } from "./ScopesUpdateModal.vue?vue&type=template&id=c2db36ce&scoped=true"
import script from "./ScopesUpdateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScopesUpdateModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ScopesUpdateModal.vue?vue&type=style&index=0&id=c2db36ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2db36ce",
  null
  
)

export default component.exports